import { defaultTheme } from './default-theme';

const switchdinTheme = {
  ...defaultTheme,
};

export { switchdinTheme };
